export function getSessionStorageKey(
  accountId: number,
  installNum: number
): string {
  return "scheduledDistribution " + accountId + " " + installNum;
}
